import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Select, { StylesConfig } from 'react-select'

const UISelect=({ isDisabled, options, selectedValues, onChange, placeholder, size, isMulti=false, ref, isClearable=false, onInputChange, label, required=false, tooltipText })=>{ 

      const [selectedOptions, setSelectedOptions] = useState(selectedValues || []);
      const { i18n } = useTranslation()

      const app = useSelector(state => state?.app);

      useEffect(()=>{
        setSelectedOptions(selectedValues)
      },[selectedValues])

      const handleSelectChange = (selectedOptions) => {
        setSelectedOptions(selectedOptions);
        if (onChange) {
          onChange(selectedOptions);
        }
      };
      const themes = {
        light: {
          optionBackgroundColor: 'transparent',
          textColor: 'black',
        },
        dark: {
          optionBackgroundColor: '#484c4e',
          textColor: '#fff'
        },
      };


  const getCustomStyles = (theme) => ({
    control: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
      padding: size==='medium'&&'7px',
      fontSize: size==='medium'&&'16px',
    }),
    input: ((provided) => ({
      ...provided,
      color: themes[theme].textColor,
    })),
    singleValue: (provided, {isDisabled}) => ({
      ...provided,
      color: isDisabled ? '#808080c4' : themes[theme]?.textColor,
     }),
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      backgroundColor: isSelected ? '#237FEA' : themes[theme].optionBackgroundColor,
      fontSize: size==='medium'&&'16px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        backgroundColor: themes[theme].optionBackgroundColor,
        fontSize: size==='medium'&&'16px',
      }),
      clearIndicator: (provided) => ({
        ...provided,
        color: 'black',
      }),
  });

  const customStyles = getCustomStyles(app?.theme);

  const getNoOptionsMessage = () => {
    return i18n?.t('common.NO_OPTIONS');
  };

  const newFunction = (input) => {
    // console.log(input);
  }

  return (
    <div>
      {label && (
        <div className='fxs b-500'>
          {label}
          {required && (
            <span className='text-danger b-500' style={{ fontSize: '14px' }}>
              *
            </span>
          )}
        </div>
      )}
      <div title={tooltipText || ''}>
        <Select
          options={Array.isArray(options) ? options : []}
          isClearable={isClearable}
          placeholder={placeholder || 'Select...'}
          value={selectedOptions}
          styles={customStyles}
          onChange={handleSelectChange}
          onInputChange={(input) =>
            typeof onInputChange === 'function' ? onInputChange(input) : newFunction(input)
          }
          autosize={true}
          isDisabled={isDisabled}
          noOptionsMessage={getNoOptionsMessage}
        />
      </div>
    </div>
  );
};

export default UISelect;
















